// src/dust/index.ts
var BARE_TRANSFER_PROTOCOLS = /* @__PURE__ */ new Set([
  "native_transfer",
  "erc20",
  "erc721",
  "erc1155"
]);
var FALLBACK_PROTOCOL_ID = "generic";
function claimedProtocols(row) {
  const primary = row.primaryProtocolId || "";
  const out = [];
  const seen = /* @__PURE__ */ new Set();
  for (const id of [primary, ...row.protocolIds ?? []]) {
    if (!id || seen.has(id)) continue;
    seen.add(id);
    if (id === FALLBACK_PROTOCOL_ID && id !== primary) continue;
    out.push(id);
  }
  return out;
}
function isBareTransfer(row) {
  const claimed = claimedProtocols(row);
  return claimed.length > 0 && claimed.every((id) => BARE_TRANSFER_PROTOCOLS.has(id));
}
var DEFAULT_DUST_USD = 0.01;
function pricedAboveDust(valueUsd, floor = DEFAULT_DUST_USD) {
  return typeof valueUsd === "number" && Number.isFinite(valueUsd) && valueUsd >= floor;
}
var DEFAULT_CAMPAIGN_MIN_RECIPIENTS = 10;
function dustReason(row, options = {}) {
  const floor = options.usdFloor ?? DEFAULT_DUST_USD;
  if (options.protectedIds && row.canonicalTxId && options.protectedIds.has(row.canonicalTxId)) {
    return null;
  }
  const usd = typeof row.valueUsd === "number" && Number.isFinite(row.valueUsd) ? row.valueUsd : null;
  const sender = (row.fromAddress ?? "").toLowerCase();
  const fromDuster = Boolean(sender && options.dustSenders?.has(sender));
  if (usd === null && !fromDuster) return null;
  if (usd !== null && usd >= floor) return null;
  if (!isBareTransfer(row)) return null;
  if (fromDuster) {
    return "Bare transfer from an address seen sending these in bulk \u2014 the shape of a dusting campaign.";
  }
  return `Bare transfer worth ${usd === 0 ? "nothing" : `under $${floor}`} \u2014 the shape of a dusting transfer.`;
}
function withoutDust(rows, read, options = {}) {
  const kept = [];
  let filtered = 0;
  let reason = null;
  for (const row of rows) {
    const why = dustReason(read(row), options);
    if (why === null) {
      kept.push(row);
      continue;
    }
    filtered += 1;
    reason = reason ?? why;
  }
  return { kept, filtered, reason };
}
function deriveDustSenders(rows, read, options = {}) {
  const minRecipients = options.minRecipients ?? DEFAULT_CAMPAIGN_MIN_RECIPIENTS;
  const recipients = /* @__PURE__ */ new Map();
  for (const row of rows) {
    const candidate = read(row);
    const sender = (candidate.fromAddress ?? "").toLowerCase();
    const recipient = (candidate.toAddress ?? "").toLowerCase();
    if (!sender || !recipient || sender === recipient) continue;
    if (!isBareTransfer(candidate)) continue;
    const seen = recipients.get(sender) ?? /* @__PURE__ */ new Set();
    seen.add(recipient);
    recipients.set(sender, seen);
  }
  const out = /* @__PURE__ */ new Set();
  for (const [sender, seen] of recipients) {
    if (seen.size >= minRecipients) out.add(sender);
  }
  return out;
}

export { BARE_TRANSFER_PROTOCOLS, DEFAULT_CAMPAIGN_MIN_RECIPIENTS, DEFAULT_DUST_USD, FALLBACK_PROTOCOL_ID, claimedProtocols, deriveDustSenders, dustReason, pricedAboveDust, withoutDust };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map